export default interface IHandleFormChangeProps {
    property: string;
    newValue: any;
    eventType?: EventType;
    index?: number;
}

export enum EventType {
    CarriersContactChange = 'CarriersContactChange',
    MainContactChange = 'MainContactChange',
    AdditionalContactChange = 'AdditionalContactChange',
}
